<div class="wrapper" *ngIf="isLoggedIn">
  <app-topnav *ngIf="isLoggedIn"></app-topnav>
      <app-sidebar *ngIf="isLoggedIn"></app-sidebar>
      <div class="content-wrapper">
          <div class="container-fluid">
            <!--Success message-->
            <div class="alert alert-success" *ngIf="showSuccessAlert">
              <strong>Success!</strong> {{ globalSuccessMessage }}
            </div>
            <!--Error message-->
            <div class="alert alert-danger" *ngIf="globalErrorMessage">
              <strong>Error:</strong> {{ globalErrorMessage }}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <!--Warning message-->
            <div class="alert alert-warning" *ngIf="globalwarningMessage">
              <strong>Warning!</strong> {{ globalwarningMessage }}
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <router-outlet></router-outlet>

          <!-- GLOBAL NOTIFICATION MODAL -->
          <div class="modal fade" id="globalNotificationModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content card card-outline card-success">
                <div class="modal-header">
                  <h5 class="modal-title" id="modalTitle">{{ modalData?.title }} ({{ modalData?.createdAt| date: 'dd-MM-yyyy h:mm a'}})</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <p id="modalBody">{{ modalData?.body }}</p>
                </div>
                <div class="modal-footer">
                  <!-- Contextual action button depending on custom payload properties -->
                  <div *ngIf="modalData?.txnType=='transfer'" class="mr-auto">
                    <a [href]="'/view-transferred-vehicle/' + modalData?.txnId" target="_blank" class="btn btn-success">
                      <i class="fas fa-eye mr-1"></i> View
                    </a>
                  </div>
                  <div *ngIf="modalData?.txnType=='receive'" class="mr-auto">
                    <a [href]="'/view-received-vehicle/' + modalData?.txnId" target="_blank" class="btn btn-success">
                      <i class="fas fa-eye mr-1"></i> View
                    </a>
                  </div>
                  <div *ngIf="modalData?.txnType=='delivery'" class="mr-auto">
                    <a [href]="'/view-transferred-vehicle/' + modalData?.txnId" target="_blank" class="btn btn-success">
                      <i class="fas fa-eye mr-1"></i> View
                    </a>
                  </div>
                  <div *ngIf="modalData?.txnType=='unshipped_bls'" class="mr-auto">
                    <a [href]="'/suppliers/bl-list'" target="_blank" class="btn btn-success">
                      <i class="fas fa-eye mr-1"></i> View Unshipped BL(s)
                    </a>
                  </div>
                  <div *ngIf="modalData?.txnType=='vessel_eta_update'" class="mr-auto">
                    <a [href]="'/update-bl/' + modalData?.txnId" target="_blank" class="btn btn-success">
                      <i class="fas fa-eye mr-1"></i> View BL
                    </a>
                  </div>
                  <div *ngIf="modalData?.txnType=='duty'" class="mr-auto">
                    <a href="{{modalData?.txnId}}" target="_blank" class="btn btn-success">
                      <i class="fas fa-eye mr-1"></i> View Entry & Payment Slip
                    </a>
                  </div>
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>

      </div>
  <app-footer></app-footer>
</div>

<div *ngIf="!isLoggedIn">
  <app-login></app-login>
</div>
